import { all, call, put, takeLatest } from 'redux-saga/effects';

import { GET_PROJECT_DATA } from 'actions/projectData/constants';
import {
  getProjectDataSuccess,
  getProjectDataError
} from 'actions/projectData';

import { getPaymentMethods } from 'actions/paymentMethods';
import { getCredits } from 'actions/credits';
import { getProjectDetails } from 'actions/projects';
import { getUsers } from 'actions/users';
import { getInstances, getInstancesStatuses } from 'actions/instances';
import { getActiveSessions, getHistoricalSessions } from 'actions/sessions';
import { getSkus } from 'actions/orders';
import { getAllRegions } from 'actions/regions/regions';

import { DATA_TYPES } from 'utils/constants';

// TODO review data fetching
export function* getProjectDataSaga({ projectId, dataTypes }) {
  const types = {
    [DATA_TYPES.ACTIVE_SESSIONS]: getActiveSessions,
    [DATA_TYPES.CREDITS]: getCredits,
    [DATA_TYPES.DETAILS]: getProjectDetails,
    [DATA_TYPES.HISTORICAL_SESSIONS]: getHistoricalSessions,
    [DATA_TYPES.INSTANCES]: getInstances,
    [DATA_TYPES.INSTANCES_STATUSES]: getInstancesStatuses,
    [DATA_TYPES.PAYMENT_METHODS]: getPaymentMethods,
    [DATA_TYPES.SKUS]: getSkus,
    [DATA_TYPES.USERS]: getUsers,
    [DATA_TYPES.REGIONS]: getAllRegions
  };

  // We normalise the dataTypes to transform any string to an object
  const amendedDataTypes = dataTypes.map((dataType) => ({
    args: [],
    ...(typeof dataType === 'string' ? { dataType } : dataType)
  }));

  try {
    // For each data type, we call the corresponding saga with the project ID
    for (let i = 0; i < amendedDataTypes.length; i += 1) {
      const { dataType, args } = amendedDataTypes[i];
      yield put(types[dataType](projectId, ...args));
    }
    yield put(getProjectDataSuccess(projectId));
  } catch (error) {
    yield put(getProjectDataError(projectId, error));
  }
}

export function* getProjectDataWatcher() {
  yield takeLatest(GET_PROJECT_DATA, getProjectDataSaga);
}

export default function* rootSaga() {
  yield all([call(getProjectDataWatcher)]);
}
